export default "__VITE_ASSET__BABnM1vY__"